import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bs4 from 'reactstrap'
import { ScaleLoader } from 'react-spinners';
import Navbar from '../Navbar'
// import Select from 'react-dropdown-select'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ReactGA from 'react-ga';
import Modal from 'react-modal';
const { proxy } = require('../../ip_api.config')

class Acc_PreviewBomLine extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: false,
            id: '',
            bom_no: '',
            bom_description: '',
            previewIBom: '',
            arr_show: [],
            arr_save: [],
            showBomLine: '',
            last: 0

        }
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            previewIBom: '',
            arr_show: [],
            arr_save: [],
            showBomLine: '',
            last: 0
        });
    }

    componentWillReceiveProps(nextProps) {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/Acc/PreviewBomLine');

        let open = nextProps.open
        let id = nextProps.id
        let db_name = nextProps.db_name
        let status = nextProps.status
        let bom_no = nextProps.bom_no
        let bom_description = nextProps.bom_description
        let go = nextProps.go
        let value_serach = nextProps.value_serach
        if (open || open === true) {
            this.setState({ modal: open, id: id, db_name: db_name, status: status, bom_no: bom_no, bom_description: bom_description, go: go, value_serach, last: 0 }, () => {
                console.log('bom_no', this.state.bom_no)
                this.getItem(this.state.db_name, 0)
                this.getBom_Preview()
            })
        }
    }

    getItem = (db_name, _value) => {
        this.setState({ isLoading: true })

        let arr = []
        let url = proxy.server + '/acc/get_item'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                db_name: db_name,
                value: _value
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push({ value: val.NAMEALIAS, label: val.ITEMID })
                })
                this.setState({ option: arr, isLoading: false }, () => this.showItem(0))
            })
    }

    addItem = () => {
        const { arr_save, bom_no, bom_description, db_name, last } = this.state
        console.log('last', this.state.last)
        if (bom_no === "" || bom_description === "") {
            alert('กรุณากรอกข้อมูลให้ครบ')
        } else {
            let temp

            let data = {
                db_name: db_name,
                user: localStorage.getItem("ID_User"),
                bom_no: bom_no,
                bom_description: bom_description,
                type: '',
                item_group: '',
                Lineno: parseInt(this.state.last) + 1,
                item_no: '',
                item_description: '',
                amount: '',
                unit: 'PCS'
            }

            temp = arr_save.concat(data)

            this.setState({
                arr_save: temp,
                last: parseInt(this.state.last) + 1
            }, () => {
                console.log('arr_save', this.state.arr_save)
                this.showItem(1)
            })
        }
    }

    getBom_Preview = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arr = []
        let url = proxy.server + '/acc/get_bomline'
        let last = 0
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("get_bomline", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr style={{ textAlign: 'center', backgroundColor: 'white' }}>
                            <td>{this.state.value_serach !== 'IMPORTED' && <bs4.Button color="danger" size='sm' onClick={() => this.onDeleteBom(val.id)}>X</bs4.Button>}</td>
                            {
                                val.db_name === 'DPL' ?
                                    <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DFIX' ?
                                        <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                        : val.db_name === 'DPT' ?
                                            <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                            : ''
                            }
                            <td>{val.BOM_Approved}</td>
                            <td>{val.BOM_ApproverPersonnelNumber}</td>
                            {/* <td>{val.BOM_PmfBOMFormula}</td>
                            <td>{val.BOM_BOMId}</td>
                            <td>{val.BOM_CheckBOM}</td>
                            <td>{val.BOM_ItemGroupId}</td>
                            <td>{val.BOM_Name}</td>
                            <td>{val.LineNum}</td> */}
                            <td>{val.ItemId}</td>
                            <td>{val.ItemDescription}</td>
                            <td>{val.BOMConsump}</td>
                            <td>{val.BOMQty}</td>
                            <td>{val.UnitId}</td>
                            <td>{val.BOMQtySerie}</td>
                            <td>{val.BOMType}</td>
                            <td>{val.Calculation}</td>
                            <td>{val.Formula}</td>
                            <td>{val.InventLocationId}</td>
                            <td>{val.InventSiteId}</td>
                            <td>{val.WrkCtrConsumption}</td>
                        </tr>
                    )
                    last = val.LineNum
                }, this)
                this.setState({ previewIBom: arr, last: last, isLoading: false })
            })
    }

    showItem = (num) => {
        console.log('last', this.state.last)

        let arr = []
        this.state.arr_save.forEach(function (val, i) {
            let type = val.bom_no.charAt(0)
            let item_group = type === 'G' ? 'FG' : type === 'H' ? 'HP' : type === 'S' ? 'SM' : type === 'P' ? 'PK' : type === 'S' ? 'SU' : '0'
            arr.push(
                <tr style={{ textAlign: 'center', backgroundColor: '#FAFAD2' }}>
                    <td>{this.state.value_serach !== 'IMPORTED' && <bs4.Button color="danger" size='sm' onClick={() => this.onDeleteTemp(i)}>X</bs4.Button>}</td>
                    {
                        val.db_name === 'DPL' ?
                            <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                            : val.db_name === 'DFIX' ?
                                <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                : val.db_name === 'DPT' ?
                                    <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                    : <td></td>
                    }
                    <td>Yes</td>
                    <td>{val.user}</td>
                    {/* <td>BOM</td>
                    <td>{val.bom_no}</td>
                    <td>No</td>
                    <td>{item_group}</td>
                    <td>{val.bom_description}</td>
                    <td>{val.Lineno}</td> */}
                    <td>
                        <bs4.Col sm='12' style={{ width: 230 }}>
                            {/* <Select className="col-md-12"
                                onChange={(e) => this.handleChangeItem(i, 'item_no', e)}
                                options={this.state.option}
                                placeholder={'ค้นหา Item'}
                            /> */}
                            <Autocomplete
                                id="combo-box-demo"
                                options={this.state.option}
                                getOptionLabel={(option) => option.label}
                                // onChange={(e) => this.setState({ selectedOption: e }, () => this.handleChangeItem(i, 'item_no', e))}
                                // onInputChange={this.setState({ index : i })}
                                onChange={(event, values) => this.handleChangeItemAutocomplete(event, values, i)}
                                size={'small'}
                                renderInput={(params) => <TextField {...params} label="กรุณาเลือก Item" variant="outlined" onChange={(e) => this.getItem(this.state.db_name, e.target.value)} />}
                            />
                        </bs4.Col>
                    </td>
                    <td>{val.item_description}</td>
                    <td>Variable</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 90 }}>
                            <bs4.Input type="text" name="amount" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>PCS</td>
                    <td>1</td>
                    <td>Item</td>
                    <td>Yes</td>
                    <td>Standard</td>
                    <td>WRM</td>
                    <td>DPLUS</td>
                    <td>FALSE</td>
                </tr>
            )

            if (num !== 0) {

                this.state.arr_save[i].type = type
                this.state.arr_save[i].item_group = item_group
            }

        }, this)

        this.setState({
            showBomLine: arr,
            arr_save: this.state.arr_save,
            // last: last
        })
    }

    onDeleteTemp = (index) => {
        this.state.arr_show.splice(index, 1)
        this.state.arr_save.splice(index, 1)
        this.setState({
            arr_show: this.state.arr_show,
            arr_save: this.state.arr_save,
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.showItem(0)
        })
    }

    onDeleteBom = (id) => {
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/acc/delete_bomline'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.props.handleClose()
                            this.getBom_Preview()
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        })
                    }
                })
        }
    }

    handleChangeItem = (index, name, _value) => {
        if (name === 'item_no') {
            let value = _value[0].value
            let item_temp = value.split('$')
            this.state.arr_save[index].item_no = item_temp[0]
            this.state.arr_save[index].item_description = item_temp[1]
        } else if (name === 'amount') {
            this.state.arr_save[index].amount = _value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.showItem(0)
        })
    }

    handleChangeItemAutocomplete = (event, values, index) => {
        console.log('index', index)
        console.log('values', values)
        if (values === null || values === 'null') {
            let _item = ""
            this.state.arr_save[index].item_no = ""
            this.state.arr_save[index].item_description = ""

            this.setState({
                item_name: _item,
                arr_save: this.state.arr_save,
                selectedOption: ""
            }, () => {
                console.log('arr_save', this.state.arr_save)
                this.showItem(0)
            })
        } else {
            let _item = values.label
            this.state.arr_save[index].item_no = values.label
            this.state.arr_save[index].item_description = values.value

            this.setState({
                item_name: _item,
                arr_save: this.state.arr_save,
                selectedOption: values.label
            }, () => {
                console.log('arr_save', this.state.arr_save)
                this.showItem(0)
            })
        }
    }

    saveItem = () => {
        console.log('arr', this.state.arr_save)
        let space = 0
        this.state.arr_save.map(function (val, i) {
            if (val.item_no === '' || val.amount === '') {
                space++
            }
        })

        if (space > 0) {
            alert('กรุณากรอกข้อมูลให้ครบ')
        } else {
            if (window.confirm("กรุณายืนยันการบันทึก")) {
                let url = proxy.server + '/acc/insert_bomLine'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify({
                        arr: this.state.arr_save,
                        id: this.state.id
                    })
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.setState({
                                bom_no: '',
                                bom_description: '',
                                showBomLine: '',
                                arr_show: [],
                                arr_save: []
                            }, () => {
                                this.props.handleClose()
                                this.getBom_Preview()
                            })
                        } else {
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        }
                    })
            }
        }
    }

    goto_editline = () => {
        let route = this.state.go
        route.push({
            pathname: '/Acc/EditBomline',
            state: { id_edit: this.state.id }
        })
    }

    render() {
        const { modal } = this.state
        return <div>
            <Modal
                isOpen={modal}
                onRequestClose={this.toggle}
                style={{
                    maxWidth: 1000,
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)'
                }}
                contentLabel="Example Modal"
            >

                <bs4.Button color='link' onClick={this.toggle} style={{ fontSize: 20, float: 'right' }}>X</bs4.Button>
                <bs4.FormGroup row style={{ marginLeft: 20 }}>
                    <h2>BOM LINE</h2>
                    {
                        this.state.value_serach !== 'IMPORTED'
                            ? this.state.status === 0
                                ? ''
                                : <bs4.Button size='sm' color="warning" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.goto_editline()}>EDIT BOM LINE</bs4.Button>
                            : ''
                    }
                </bs4.FormGroup>
                <bs4.FormGroup row style={{ marginLeft: 20, marginTop: 20 }}>
                    <bs4.Label style={{ fontWeight: 500 }}>Bom No</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input type="text" name="bom_no" disabled onChange={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.setState({ bom_no: e.target.value })} defaultValue={this.state.bom_no} />
                    </bs4.Col>
                    <bs4.Label style={{ fontWeight: 500 }}>bom_description</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input type="text" name="bom_description" disabled onChange={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.setState({ bom_description: e.target.value })} defaultValue={this.state.bom_description} />
                    </bs4.Col>
                    {
                        this.state.value_serach !== 'IMPORTED'
                            && <div>
                                <bs4.Button size='sm' style={{ fontWeight: 500 }} onClick={() => this.addItem()}>+ ADD</bs4.Button>
                                <bs4.Button size='sm' color="warning" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.saveItem()}>SAVE</bs4.Button>
                            </div>
                    }

                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <br />
                <bs4.Table bordered hover style={{ fontSize: 13.5 }}>
                    <thead style={{ backgroundColor: '#8f8f8f', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th></th>
                            <th>ฐานข้อมูล</th>
                            <th>BOM_<br />Approved</th>
                            <th>BOM_<br />Approver<br />Personnel<br />Number</th>
                            <th>ItemId</th>
                            <th>ItemDescription</th>
                            <th>BOM<br />Consump</th>
                            <th>BOM<br />Qty</th>
                            <th>UnitId</th>
                            <th>BOM<br />Qty<br />Serie</th>
                            <th>BOM<br />Type</th>
                            <th>Calculation</th>
                            <th>Formula</th>
                            <th>Invent<br />Location<br />Id</th>
                            <th>Invent<br />SiteId</th>
                            <th>WrkCtr<br />Con<br />sumption</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewIBom}
                        {this.state.showBomLine}
                    </tbody>
                </bs4.Table>
            </Modal>
            {/* <bs4.Modal isOpen={modal} toggle={this.toggle} size='lg' style={{ maxWidth: '80% !important' }}>
                <bs4.ModalHeader toggle={this.toggle}>
                    BOM LINE
                    {
                        this.state.status === 0
                            ? ''
                            : <bs4.Button size='sm' color="warning" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.goto_editline()}>EDIT BOM LINE</bs4.Button>
                    }
                </bs4.ModalHeader>
                <bs4.ModalBody toggle={this.toggle}>
                    <bs4.FormGroup row style={{ marginLeft: 20, marginTop: 20 }}>
                        <bs4.Label style={{ fontWeight: 500 }}>Bom No</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="bom_no" onChange={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.setState({ bom_no: e.target.value })} defaultValue={this.state.bom_no} />
                        </bs4.Col>
                        <bs4.Label style={{ fontWeight: 500 }}>bom_description</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="bom_description" onChange={(e) => e.target.value.length > 50 ? alert('ห้ามกรอกเกิน 50 ตัวอักษร') : this.setState({ bom_description: e.target.value })} defaultValue={this.state.bom_description} />
                        </bs4.Col>
                        <bs4.Button size='sm' style={{ fontWeight: 500 }} onClick={() => this.addItem()}>+ ADD</bs4.Button>
                        <bs4.Button size='sm' color="warning" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.saveItem()}>SAVE</bs4.Button>

                        <ScaleLoader
                            size={15}
                            loading={this.state.isLoading}
                        />
                        <ScaleLoader
                            size={15}
                            loading={this.state.isLoading}
                        />
                        <ScaleLoader
                            size={15}
                            loading={this.state.isLoading}
                        />
                    </bs4.FormGroup>
                    <br />
                    <bs4.Table bordered hover style={{ fontSize: 13.5 }}>
                        <thead style={{ backgroundColor: '#8f8f8f', color: '#000' }}>
                            <tr style={{ textAlign: 'center' }}>
                                <th></th>
                                <th>ฐานข้อมูล</th>
                                <th>BOM_<br />Approved</th>
                                <th>BOM_<br />Approver<br />Personnel<br />Number</th>
                                <th>ItemId</th>
                                <th>ItemDescription</th>
                                <th>BOM<br />Consump</th>
                                <th>BOM<br />Qty</th>
                                <th>UnitId</th>
                                <th>BOM<br />Qty<br />Serie</th>
                                <th>BOM<br />Type</th>
                                <th>Calculation</th>
                                <th>Formula</th>
                                <th>Invent<br />Location<br />Id</th>
                                <th>Invent<br />SiteId</th>
                                <th>WrkCtr<br />Con<br />sumption</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.previewIBom}
                            {this.state.showBomLine}
                        </tbody>
                    </bs4.Table>
                </bs4.ModalBody>
            </bs4.Modal> */}
        </div >
    }
}

export default Acc_PreviewBomLine